import React from "react";
import PageBanner from "../../components/general/PageBanner";
import ActivitiesTable from "./ActivitiesTable";

function ActivitesPage() {
  return (
    <>
      <PageBanner
        heading='Activities'
        text='Track all the transaction activities in our blockchain video application'
      ></PageBanner>

      <section className='py-5'>
        <div className='container py-5'>
          <div className='mb-5'>
            <ActivitiesTable />
          </div>
        </div>
      </section>
    </>
  );
}

export default ActivitesPage;
